<template>
  <div class="animated fadeIn list-of-tendering">
    <b-card>
      <div slot="header">List of - Tendering/Canvasing Sheet         
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="primary mr-1" @click="deleteConfirm">Delete</b-button>
          <!-- <b-button variant="primary mr-1" @click="print()"><i class="fa fa-print"></i> Print</b-button> -->
          <b-button variant="primary mr-1" @click="approvalConfirm()"><i class="fa fa-paper-plane"></i> Approval</b-button>
          <b-button variant="primary mr-1" @click="generatePO" >Generate PO</b-button>
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</b-button>
          <b-button variant="primary mr-1" @click="togleFilter()"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col xl="6">
              <b-row>
                <b-col lg="5">
                    <b-input-group >
                      <b-input-group-prepend><label>Tender Number</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.nomor" placeholder="Tender No.(% for wildcard)"></b-form-input>
                    </b-input-group>
                  </b-col>
                <b-col  lg="7">
                    <b-input-group >
                      <b-input-group-prepend><span class="pt-2">PR Number &nbsp;</span></b-input-group-prepend>
                      <b-form-input v-model="tblData.requestno" placeholder="Request Number"></b-form-input>
                    </b-input-group>
                </b-col>
              </b-row>          
            <b-input-group >
                <b-input-group-prepend><label>Dimension Name</label></b-input-group-prepend>
                <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
                <b-input-group-prepend><span class="input-group-text">value</span></b-input-group-prepend>
                <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value"></b-form-input>
              </b-input-group>
              <b-input-group >
                <b-input-group-prepend><label>Tender Date</label></b-input-group-prepend>
                <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
                <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
              </b-input-group>
        </b-col>
        <b-col xl="5">
            <b-input-group >
                <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                <b-form-input v-model="tblData.uraian" ></b-form-input>
            </b-input-group>
            <b-input-group >
              <b-input-group-prepend><label>Item Name/Desc.</label></b-input-group-prepend>
              <b-form-input v-model="tblData.item" placeholder="Material/Service Name"></b-form-input>
              <b-input-group-append>
                <b-button class="btn btn-success ml-1" @click="search()">
                  <i class="fa fa-refresh"></i> Apply Filter
                </b-button>
              </b-input-group-append>
            </b-input-group>
            <b-input-group >
              <b-input-group-prepend><label >Progress Status &nbsp;</label></b-input-group-prepend>
              <b-form-select v-model="tblData.status" :plain="true" :options="progressStatus" style="width:25% !important;"></b-form-select>
              <b-input-group-prepend><span class="p-2">Approval </span></b-input-group-prepend>
              <b-form-select v-model="tblData.statuswf" :plain="true" :options="dataList.approvalStatus"></b-form-select>
              <b-input-group-append>
                <b-button class="btn btn-secondary ml-1" @click="clearFilter()">
                  <i class="fa fa-eraser"></i>Clear
                </b-button>
              </b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>

      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive striped hover
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"  @row-clicked="rowClicked" 
      >
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowEdit(data.item)" href="#"  style="padding:0 !important;">Edit</b-dropdown-item>
          <b-dropdown-item @click="rowApproval(data.item)" href="#" :disabled="(data.item.idstatus!=4)" style="padding:0 !important;">Approval</b-dropdown-item>
          <b-dropdown-item @click="rowGenerate(data.item)" href="#" :disabled="(data.item.idstatus!=4)" style="padding:0 !important;">Generate PO</b-dropdown-item>
          <b-dropdown-item @click="rowDel(data.item)" href="#"  style="padding:0 !important;"> Delete</b-dropdown-item>
        </b-dropdown>
      </template>        
        <template v-slot:cell(tanggal)="data">
          {{ data.item.tanggal | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(requisition)="data">
                <span v-if="(data.item.requisition)"><b-link @click.stop="getAttachment(data.item)">{{data.item.requisition}}  <i class="fa fa-paperclip"></i></b-link></span>
        </template>

        <template v-slot:cell(nmStatus)="data">
          {{data.item.nmStatus}}
          <div v-if="data.item.idstatus==4" style="margin:0;padding:0">           
              <div v-if="data.item.send2wf==0" style="background-color:yellow;">           
                DRAFT (NO APPROVAL)
              </div>
              <div v-else> 
                <div v-if="data.item.iscomplete==0">           
                  APPROVAL ON PROCESS
                </div>
                <div v-else>           
                    <div v-if="data.item.issuccess==1"  style="background-color:#04f681;">           
                      APPROVAL APPROVED
                    </div>
                    <div v-else style="background-color:#f86c6b;">           
                      APPROVAL REJECTED
                    </div>
                </div>
              </div>
          </div>
        </template>
      </b-table>
      <b-row>
        <b-col cols="5">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="2" >
          <b-input-group>
              <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
              <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
          </b-input-group>
        </b-col>        
        <b-col cols="5">            
          <b-pagination v-if="pagination"
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
      <p class="mb-1">1 record is about to be permanently deleted</p>
      <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
    </b-modal>
    <b-modal v-model="showApprovalConfirm" header-bg-variant="primary"  title="Approval Form" size="lg" :centered="true" hide-footer>
        <b-row>
          <b-col lg="6">
            <b-input-group>
              <b-input-group-prepend><label>Tendering Number</label></b-input-group-prepend>
              <b-form-input v-model="model.nomor" disabled></b-form-input>
            </b-input-group>
          </b-col>
          <b-col lg="6">
            <b-input-group>
              <b-input-group-prepend><label>Tendering Date</label></b-input-group-prepend>
              <b-form-input v-model="model.tanggal" type="date" disabled></b-form-input>
            </b-input-group>
          </b-col>
        </b-row>
        <b-input-group>
          <b-input-group-prepend><label>Note/Description</label></b-input-group-prepend>
          <b-form-input v-model="model.uraian" placeholder="Note/Description" disabled></b-form-input>
        </b-input-group>
        <div v-if="(this.model.send2wf==1)">
          <label>Workflow process history</label>
          <div class="report-wraper">
              <table width="100%">
              <thead>
              <tr>
              <th width="120px">Assign Date</th>
              <th width="220px">Assign To</th>
              <th width="80px">Action Take</th>
              <th >Comment</th>
              <th width="120px">Complete Date</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="row in approvalHistory" :key="row.taskassignkey">
                <td> {{row.assignstr | moment("dddd , DD-MMM-YYYY hh:mm:ss")}} </td>
                <td>{{row.crewnik}} | {{row.crewname}}</td>
                <td>{{row.actiontake}} 
                    <p v-if="(row.crewname !== row.actionBy)">{{row.actionBy}}</p></td>
                <td>{{row.message}}</td>
                <td><span v-if="(row.completeddate)">{{row.completeddate | moment("ddd DD-MMM-YYYY hh:mm:ss")}}</span></td>
                </tr>
                <tr> <td colspan="5" class="subtotal"></td></tr>
                </tbody>
                </table>
            </div>
            <b-row class="justify-content-center mt-1" >
                <b-button variant="primary" @click="printApproval"><i class="fa fa-print"></i> Print Approval</b-button>
                <b-button variant="danger" class="ml-1" v-if="((model.iscomplete==0) || (model.isreject==1) || (approvalHistory.length==0))" @click="showApprovalCancelConfirm=true" > <i class="fa fa-undo"></i> Cancel Approval</b-button>
                <b-button variant="secondary" class="ml-1" @click="showApprovalConfirm=false" > <i class="fa fa-close"></i> Close</b-button>
            </b-row>
        </div>
        <div no-body v-else>
          <label>Add Attachment</label>
            <b-form-file
            v-model="file"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
            ></b-form-file>
            <div class="mt-3" >Selected file: <strong>{{ file ? file.name : '' }}</strong></div>   
            <b-row class="justify-content-center mt-1" v-if="(showConfirmNoFile)">
                <label style="width:260px !important;">Send without attachment, are you sure?</label>
                  <b-form-radio-group  v-model="confirmNoFile"  class="ml-1" >
                      <b-form-radio :value="true">Yes</b-form-radio>
                      <b-form-radio :value="false">No</b-form-radio>
                  </b-form-radio-group>
            </b-row>
            <b-row class="justify-content-center mt-1" >
                <b-button variant="primary" @click="approval"><i class="fa fa-paper-plane"></i> Send to Workflow</b-button>
                <b-button variant="secondary" class="ml-1" @click="showApprovalConfirm=false" > <i class="fa fa-close"></i> Close</b-button>
            </b-row>
        </div>
    </b-modal>
    <b-modal v-model="showApprovalCancelConfirm" title="Remove from workflow Approval Process?" :centered="true" @ok="approvalUndo">
      <p class="mb-1">The selected a row of data will be removed from Workflow?</p>
    </b-modal>
      <b-modal v-model="showAttachment" header-bg-variant="primary"  title="Canvasing Sheet Attachment" size="lg" :centered="true" ok-only>
            <b-row>
                <b-col lg="6">
                    <b-input-group>
                        <b-input-group-prepend><label>Canvasing No.</label></b-input-group-prepend>
                        <b-form-input v-model="model.nomor" readonly></b-form-input>
                    </b-input-group>
                </b-col>
            </b-row >    
            <div class="report-wraper">
              <table width="100%">
                <thead>
                  <tr>
                    <th width="200px">Attached Date</th>
                    <th >File Name</th>
                    <th width="100px">Attached By</th>
                    <th width="40px">action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in attachmens" :key="row.attachmentKey">
                    <td> {{row.modified | moment("dddd , DD-MMM-YYYY hh:mm:ss")}} </td>
                    <td>                                
                        <b-link @click="attachmentDownload(row)">{{row.attchFileNm}}</b-link>
                    </td>
                    <td>{{row.createby}}</td>
                    <td>                                
                      <div class="text-center" v-if="(model.iscomplete==0)">
                      <a href="javascript:void(0)" class="text-danger" @click="delAttachment(row)">
                          <i class="fa fa-trash"></i>
                      </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          <div no-body v-if="(model.iscomplete==0)">
            <label>Add Attachment</label>
              <b-form-file
              v-model="file"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              ></b-form-file>
              <b-row class="mt-1" >
                  <span class="p-2" >Selected file: <strong>{{ file ? file.name : '' }}</strong></span>   
                  <b-button variant="success" @click="attachmentSave" class="sm" v-if="(file)"><i class="fa fa-paperclip"></i> Add Attachment</b-button>
              </b-row>
          </div>
      </b-modal>

  </div>
</template>

<style lang="scss">
.list-of-tendering {
    table {
      td:nth-child(1) {
        width: auto;
      }
      td:nth-child(2) {
        width: auto;
      }
      td {
        .dropdown-item {
            padding: 0.1rem 1.5rem !important;
            font-size: smaller !important;
        }    
      }
    }
}
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import task from "../../apis/task";
import proctender from "../../apis/proctender";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
toastr.init();

export default {
  components: {Loading},
  data() {
    return {
      showFilter: false,
      showAttachment: false,   
      attachmens:[],
      showDelConfirm: false,
      showApprovalConfirm: false,
      approvalHistory:[],
      file:null,
      confirmNoFile:false,
      showConfirmNoFile:'',
      showApprovalCancelConfirm: false,
      isLoading:false,
      showReport:false,
      reportUrl: null,
        items: [],
      tblData: {
        page: 1,
        limit: 20,
        total: 0,
        tgl1:this.$store.state.user.tglaktif,
        tgl2:moment().format('YYYY-MM-DD'),
        sortBy: 'nomor',
        sortDesc: true,
        DimCol:'Dim1',
        status:''
      },
      pagination:false,
      model:{},
      postGroups:[],
      progressStatus : [],
      dataList: {
        // openStatus: dropdown.openClose,
        approvalStatus: dropdown.approvalStatus,
        // prProgress : dropdown.prProgress   , 
        // barter: dropdown.YesNoAll   
      }      

    };
  },
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    tblFields(){
      const fields=[
        {
          key: "action",
          label: "",
          thStyle: "width:40px",
          thClass: "text-center",
        },
          {
            key: "nomor",
            thStyle: "min-width:100px",
            label: "Canvasing Number",
            sortable: true
          },
          {
            key: "tanggal",
            thStyle: "width:90px",
            label: "Created Date",
            sortable: true
          },
          {
            key: "uraian",
            label: "Description",
            sortable: true
          },
          {
            key: "requisition",
            label: "Requisition Number",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "nmStatus",
            label: "Status Progress",
            sortable: true
          },
          {
            key: "po",
            label: "Generated P.O",
            sortable: true
          },
          {
            key: "createby",
            thStyle: "width:90px",
            label: "Handled By",
            sortable: true
          },
        ];
        // const dims = this.$store.state.dimension;
        // for (let i = 0; i < dims.length; i += 1) {
        //   fields.push(          {
        //     key: `${dims[i].value}Txt`,
        //     thStyle: "width:100px",
        //     label: dims[i].text
        //   },)
        // }
      return fields;
    },
    dimCol() {
        return this.tblData.DimCol;
    },
    approvalStatus(){
      return this.dataList.approvalStatus
    }  
  },
  watch:{
    dimCol: function(newval) {
        this.tblData.DimVal="";
        this.tblData.DimValInfo="";
        this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
    },
    "tblData.status": function(newval) {
        this.tblData.statusnm=this.progressStatus.find(d => d.value === newval).text;
    }
  },
  created: async function(){
      const accList = await proctender.postgroup();
      this.postGroups = accList.reduce((newArr,item) =>{
            newArr.push(item);
            return newArr;
        },[{ value: '', text: '--- ALL ---'}]);

      // status
      const statusList = await proctender.getStatusList();
      this.progressStatus = statusList.reduce((newArr,item)=>{
        newArr.push({ value: item.idstatus, text: item.nmStatus});
        return newArr;
      },[{ value: '', text: '--- ALL ---'}])
    
      // const tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
      // this.tblData.tgl1=this.$store.state.user.tglaktif;
      // this.tblData.tgl2=tgl2.format('YYYY-MM-DD');
      // const tglaktif = moment(new Date(), 'YYYY-MM-DD');
      // this.tblData.tgl1 =  tglaktif.startOf('month').format('YYYY-MM-DD');
      // this.tblData.tgl2 =  tglaktif.endOf('month').format('YYYY-MM-DD');

  },  
  // sockets: {
  //   task_changed: function(data) {
  //     const ada = this.items.find(i=> i.idTender==data.taskkey);
  //     if (ada) {
  //       this.refresh();
  //     }
  //   }
  // },

  methods: {
    async generatePO(){
      //  Note : mengambil yg sudah terselected -> jadikan PO
      //  saat sudah digenerate PO -> tender_detail_rfq kolom pohdrkey diisi ,pastikan tidak tergenerate ulang saat sudah ada pohdrkey
      if (this.model.idTender) {
          try {
            if (this.model.idstatus==4) {
                const itemnosupplier = await proctender.itemnosupplier(this.tblData);
                console.log('itemnosupplier: ',itemnosupplier);
                if (itemnosupplier){
                    toastr.error(`Vendor/Supplier belum dipilih, untuk item:${itemnosupplier.partnumber} | ${itemnosupplier.itemname}`,'ERROR MESSAGE',10000);
                    return;
                }
                // toastr.warn('function generate PO not yet Available/Ready');
              this.isLoading=true;
              const ds = await proctender.generatepo(this.model);
              this.model.po=ds.po;
              toastr.success(this.model.po,'PO Generated',10000);
              this.refresh();
              this.isLoading=false;
            } else {
              console.log('this.approvalStatus :',this.approvalStatus);
              const status4Approval= this.approvalStatus.find( stat => stat.idstatus==4);
              const msg = `Only for Tendering with progress status: "${ (status4Approval) ? status4Approval.text : 'Pemilihan Best Supplier'}"  , has been DONE`;
              toastr.error(msg,'ERROR MESSAGE',10000);
            }
          } catch (error) {
            this.isLoading=false;
              console.log('error :',error);
            if (error.sql) {
              console.log(error.sql);
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
          }
      } else {
          toastr.warn('Please select a row that want to Generate PO!');
      }
    },
    // onFiltered(filteredItems) {
    //   this.tblData.total = filteredItems.length;
    // },
    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.tenderlist) {
            this.tblData[key] = filter.tenderlist[key];
            filtered=true;
        }
        if (filtered === true) {
          if (!(filter.tenderlist.tgl1)) {
            this.tblData.tgl1='';
            this.tblData.tgl2='';
          }
          this.showFilter=filtered;
          delete filter.tenderlist;
          this.$store.commit("filter", filter);
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=true; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await proctender.list(this.tblData);      
                  this.pagination=true;
                  this.items = list;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                  console.log('error : ', error);
                  if (error.sql) {
                      toastr.error(error.sql,'ERROR MESSAGE',10000);
                  } else if (error.sqlMessage) {
                      toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                  } else if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }   
                }
            }
        } else {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await proctender.list(this.tblData);      
                  this.pagination=true;
                  this.items = list;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                  console.log('error : ', error);
                  if (error.sql) {
                      toastr.error(error.sql,'ERROR MESSAGE',10000);
                  } else if (error.sqlMessage) {
                      toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                  } else if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }   
                }
        }
    },    
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },
    clearFilter(ctx) {
        this.tblData.vendor= '';
        this.tblData.item=  '';
        this.tblData.uraian=  '';
        this.tblData.nomor=  '';
        this.tblData.requestno=  '';
        this.tblData.postgroup=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.DimVal=  '';
        this.tblData.status=  '';
    },
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    saveFilter() {
      const keys = ['sortBy','sortDesc','uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2','status', 'nomor', 'vendor', 'requestno', 'postgroup', 'item', 'status'];
      let filtered = false;
      const tenderlist={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              tenderlist[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          tenderlist.page=this.tblData.page;
          tenderlist.limit=this.tblData.limit;
          tenderlist.sortBy=this.tblData.sortBy;
          tenderlist.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.tenderlist=tenderlist;
          this.$store.commit("filter", filter);
      }
    },    
    rowEdit(record) {
      this.model = record;
      this.edit();
    },
    rowApproval(record) {
      this.rowClicked(record);
        this.approvalConfirm();        
    },
    rowGenerate(record) {
      this.rowClicked(record);
        this.generatePO();        
    },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();
    },

    add(){
      this.saveFilter();
        router.push({name :'procurement.tenderingfrm1'});              
    },
    edit: function() {
        // console.log('selected : ',this.model);
        if (this.model) {
              this.saveFilter();
              let status= this.model.idstatus;
              if (status<1) status=1;
              if (status>4) status=4;

              router.push({name :`procurement.tenderingfrm${status}`, params: { idTender: this.model.idTender}});              
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    deleteConfirm() {
      if (this.model) {
        this.showDelConfirm = true;
      } else {
          toastr.warn('Please select a row that want to be Delete!');
      }
    },
    deleteData: async function() {
      try {
        this.isLoading=true;
        await proctender.remove(this.model);
      this.refresh();
        // const index= this.items.findIndex(r => (r.idTender==this.model.idTender));
        // this.items.splice(index, 1);
        this.isLoading=false;
      } catch (error) {
                  console.log('error : ', error);
                  if (error.sql) {
                      toastr.error(error.sql,'ERROR MESSAGE',10000);
                  } else if (error.sqlMessage) {
                      toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                  } else if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }   
      }
    },

    rowClicked(record, index) {
      // if (this.model.idTender == record.idTender) {
      //     this.edit();
      // } else {
        if ((this.model) && (this.model._rowVariant)) {
            delete this.model._rowVariant;
        }
        this.model = record;
        record._rowVariant= 'info';
        this.$forceUpdate();
      // }
    },
    getAttachment: async function(record) {
      try {
        this.model = record;
        this.isLoading=true;
        const data = await task.getAttachment({taskkey: record.idTender});
        this.attachmens=data;    
        this.showAttachment=true;            
        this.isLoading=false;
      } catch (error) {
        this.isLoading=false;
                  console.log('error : ', error);
                  if (error.sql) {
                      toastr.error(error.sql,'ERROR MESSAGE',10000);
                  } else if (error.sqlMessage) {
                      toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                  } else if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }   
      }
    },    
    attachmentSave : async function(evt) {
          evt.preventDefault()
          if (this.invalidFile) {
              console.log('validation : ', this.$v.file);
              console.log('model : ',this.file);
            //   this.showAddAttachment=true;
              toastr.error('Please choose a file');
        } else {
            toastr.info(`Attachment Save`);
            this.isLoading=true;
            try {
                const formData = new FormData();
                formData.append('file', this.file);
                formData.append('filename', this.file.name);
                formData.append('tablekey', this.model.idTender);
                formData.append('tableName', 'tender_header');
                const response = await task.attachmentSave(formData);
                console.log('response : ',response);
                const data = await task.getAttachment({taskkey: this.model.idTender});
                this.attachmens=data;    
                this.file=null;
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
            }
        }
    },   
    attachmentDownload : async function(fl) {
        this.isLoading=true;
        try {
            const response = await task.attachmentDownload(fl);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            console.log('error : ', error);
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }   
        }
    },      
    delAttachment : async function(obj) {
      const pesan=`Do You realy want to delete the attachment "${obj.attchFileNm}"?`;
      this.$bvModal.msgBoxConfirm(pesan, {
      title: 'Please Confirm',
      size: 'sm',
      buttonSize: 'sm',
      okVariant: 'success',
      okTitle: 'YES',
      cancelTitle: 'NO',
      footerClass: 'p-2',
      hideHeaderClose: false,
      centered: true
      })
      .then(async(value) => {
          if (value==true){
              this.isLoading=true;
                try {
                    await task.delAttachment(obj);
                  const data = await task.getAttachment({taskkey: this.model.idTender});
                  this.attachmens=data;    
                    this.isLoading=false;    
                } catch (error) {
                    this.isLoading=false;
                    console.log('error : ', error);
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }   
                }
          }
              // this.close();
      })
      .catch(err => {
      // An error occurred
      })                

    },      

    approvalConfirm: async function () {
        if (this.model.idTender) {
          if (this.model.iscomplete==1){
                try {
                  const data = await task.approvalhistory({key: this.model.idTender});
                  this.approvalHistory=data;                
                  this.showApprovalConfirm = true;
                  this.model.tanggal = this.model.tanggal ? moment(this.model.tanggal).format('YYYY-MM-DD') : '';                
                } catch (error) {
                  console.log('error : ', error);
                  if (error.sql) {
                      toastr.error(error.sql,'ERROR MESSAGE',10000);
                  } else if (error.sqlMessage) {
                      toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                  } else if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }   
                }

          } else {
              if (this.model.idstatus==4) {
                    if (this.model.send2wf==1) {
                        try {
                          const data = await task.approvalhistory({key: this.model.idTender});
                          this.approvalHistory=data;                
                        } catch (error) {
                          console.log('error : ', error);
                          if (error.sql) {
                              toastr.error(error.sql,'ERROR MESSAGE',10000);
                          } else if (error.sqlMessage) {
                              toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                          } else if (error.message) {
                              toastr.error(error.message,'ERROR MESSAGE',10000);
                          } else {
                              toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                          }   
                        }
                    } else {
                        const itemnosupplier = await proctender.itemnosupplier({key: this.model.idTender});   
                        if (itemnosupplier) {
                          if (itemnosupplier.length>0){
                              toastr.error(`Vendor/Supplier belum dipilih, untuk item:${itemnosupplier.partnumber} | ${itemnosupplier.itemname}`,'ERROR MESSAGE',10000);
                              return;
                          }
                        } 
                    }
                    this.showApprovalConfirm = true;
                    this.model.tanggal = this.model.tanggal ? moment(this.model.tanggal).format('YYYY-MM-DD') : '';                
              } else {
                const status4Approval= this.approvalStatus.find( stat => stat.idstatus==4);
                const msg = `APPROVAL only for Tendering with progress status: "${ (status4Approval) ? status4Approval.text : 'Pemilihan Best Supplier'}" `;
                toastr.error(msg,'ERROR MESSAGE',10000);
              }

          }
        } else {
            toastr.warn('Please select a row that want to be sent to workflow Approval!');
        }
    }, 
    approval: async function(evt){
        evt.preventDefault()
        try {
            const formData = new FormData();
            if (!(this.file)) {
              if (this.confirmNoFile==false){
                toastr.info('Send without attachment, are you sure?');
                this.showConfirmNoFile=true;
                return;
              }
            } else {
              formData.append('file', this.file);
              formData.append('filename', this.file.name);
            }
            formData.append('tablekey', this.model.idTender);
            this.showApprovalConfirm = false;
            this.isLoading=true;
            const resp = await proctender.approval(formData);
            this.model.send2wf=1;
            this.refresh();
            this.isLoading=false;
            if (resp.message) {
                toastr.warn(resp.message,'warning',10000);
            }
        } catch (error) {
            this.isLoading=false;
                  console.log('error : ', error);
                  if (error.sql) {
                      toastr.error(error.sql,'ERROR MESSAGE',10000);
                  } else if (error.sqlMessage) {
                      toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                  } else if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }   
        }
    },  
    approvalUndo: async function(){
        // this.isLoading=true;
        try {
            this.showApprovalConfirm = false;
            await proctender.approvalUndo(this.model);
            this.model.send2wf=0;
            this.showApprovalConfirm = false;
            this.refresh();
            // this.isLoading=false;
        } catch (error) {
            // this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    printApproval: async function()
    {
      if (this.model.idTender) {
          try {
                this.showReport=true;
              this.reportUrl= await task.approvalprint({key: this.model.idTender});
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
                  console.log('error : ', error);
                  if (error.sql) {
                      toastr.error(error.sql,'ERROR MESSAGE',10000);
                  } else if (error.sqlMessage) {
                      toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                  } else if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }   
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },      
    // print: async function()
    // {
    //   if (this.model) {
    //       try {
    //           this.reportUrl= await proctender.printTendering(this.model);
    //           if (this.$isMobile()){
    //               window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
    //           } else {
    //             this.showReport=true;
    //           }
    //       } catch (error) {
    //           if (error.message) {
    //               toastr.error(error.message);
    //           } else {
    //               toastr.error(JSON.stringify(error));
    //           }
    //       }
    //     } else {
    //       try {
    //           this.reportUrl= await proctender.printTendering(this.tblData);
    //           if (this.$isMobile()){
    //               window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
    //           } else {
    //             this.showReport=true;
    //           }
    //       } catch (error) {
    //           if (error.message) {
    //               toastr.error(error.message);
    //           } else {
    //               toastr.error(JSON.stringify(error));
    //           }
    //       }

    //         // toastr.warn('Please select a row that want to be Printed!');
    //     }
    // },
    exportxls: async function() {
      this.isLoading = true;
      try {
        const response = await proctender.exportxls(this.tblData);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Tender_Canvasing_sheet.xlsx');
        document.body.appendChild(link);
        link.click();
        // window.location.assign(url);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
                  console.log('error : ', error);
                  if (error.sql) {
                      toastr.error(error.sql,'ERROR MESSAGE',10000);
                  } else if (error.sqlMessage) {
                      toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                  } else if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }   
      }
    },
    close(){
      router.push({name:'procurement.home'});
    //   console.log('this.$store.state.prevRoute.name : ',this.$store.state.prevRoute.name);
      // if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'procurement.tendering')) {
      //   router.push({name:this.$store.state.prevRoute.name});
      // } else {
      //   // router.push({name:'payable.apinv'});
      //     router.push("home");
      // }
    }

  }
};
</script>
